// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__6AzjF","content":"modal_content__bpykS","close":"modal_close__GvCYX","body":"modal_body__MHvpV"};